import { render, staticRenderFns } from "./SuggestedPassAcceptButtons.vue?vue&type=template&id=30cce988&scoped=true"
import script from "./SuggestedPassAcceptButtons.vue?vue&type=script&lang=js"
export * from "./SuggestedPassAcceptButtons.vue?vue&type=script&lang=js"
import style0 from "./SuggestedPassAcceptButtons.vue?vue&type=style&index=0&id=30cce988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cce988",
  null
  
)

export default component.exports